<template>
  <div class="app-container">
    <el-descriptions title="订单信息" :column="4">
      <el-descriptions-item label="订单编号" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ oldMachineSubsidyEntity.subsidyNo }}</el-descriptions-item>
      <el-descriptions-item label="订单金额" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ oldMachineSubsidyBill.amount }}</el-descriptions-item>
      <el-descriptions-item label="旧机品类" :labelStyle="labelStyle" :contentStyle="contentStyle">{{
        oldMachineCategoryStrFun(oldMachineSubsidyEntity.oldMachineType)
      }}</el-descriptions-item>
      <el-descriptions-item label="订单状态" :labelStyle="labelStyle" :contentStyle="contentStyle">
        {{ orderStatusStrFun(oldMachineSubsidyEntity.onlineStatus) }}
      </el-descriptions-item>
      <el-descriptions-item label="订单创建时间" :labelStyle="labelStyle" :contentStyle="contentStyle">{{
        formatDateTime(oldMachineSubsidyEntity.createdDate)
      }}</el-descriptions-item>
      <el-descriptions-item label="订单完成时间" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ oldMachineSubsidyEntity.completedDate }}</el-descriptions-item>
      <el-descriptions-item label="回收地址" :labelStyle="labelStyle" :contentStyle="contentStyle">
        {{ oldMachineSubsidyEntity.recoveryAddress }}
        <span v-if="oldMachineSubsidyEntity.recoveryAddress">
            <img v-if="!dataVisible.recoveryAddress" src="@/assets/eye-close.png" @click="toggleVisibility('recoveryAddress')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('recoveryAddress')" />
          </span>
      </el-descriptions-item>
      <el-descriptions-item label="合作方" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ oldMachineSubsidyBill.payAccountName }}</el-descriptions-item>
      <el-descriptions-item label="联系人" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ oldMachineSubsidyEntity.recoveryContact }}</el-descriptions-item>
      <el-descriptions-item label="联系电话" :labelStyle="labelStyle" :contentStyle="contentStyle"
        >{{ oldMachineSubsidyEntity.recoveryTel }}
        <span v-if="oldMachineSubsidyEntity.recoveryTel">
            <img v-if="!dataVisible.recoveryTel" src="@/assets/eye-close.png" @click="toggleVisibility('recoveryTel')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('recoveryTel')" />
          </span>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions title="账单信息" :column="4" style="margin-top: 20px;">
      <el-descriptions-item label="账单编号" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ oldMachineSubsidyBill.billNo }}</el-descriptions-item>
      <el-descriptions-item label="交易流水号" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ oldMachineSubsidyBill.payNo }}</el-descriptions-item>
      <el-descriptions-item label="申请类型" :labelStyle="labelStyle" :contentStyle="contentStyle">代付</el-descriptions-item>
      <el-descriptions-item label="资金类型" :labelStyle="labelStyle" :contentStyle="contentStyle">
        {{ oldMachineSubsidyBill.expenseType == 1 ? '旧机费用' : '推荐费用' }}
      </el-descriptions-item>
      <el-descriptions-item label="申请金额" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ oldMachineSubsidyBill.amount }}</el-descriptions-item>
      <el-descriptions-item label="申请时间" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ formatDateTime(oldMachineSubsidyBill.applyDate) }}</el-descriptions-item>
      <el-descriptions-item label="到账时间" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ formatDateTime(oldMachineSubsidyBill.accountDate) }}</el-descriptions-item>
      <el-descriptions-item label="收款人" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ oldMachineSubsidyBill.receiverAccountName }}</el-descriptions-item>
      <el-descriptions-item label="收款账号" :labelStyle="labelStyle" :contentStyle="contentStyle"
        >{{ oldMachineSubsidyBill.receiverAccountNo }}
        <span v-if="oldMachineSubsidyBill.receiverAccountNo">
            <img v-if="!dataVisible.receiverAccountNo" src="@/assets/eye-close.png" @click="toggleVisibility('receiverAccountNo')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('receiverAccountNo')" />
          </span>
      </el-descriptions-item>
      <el-descriptions-item label="处理状态" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ dealStatusStrFun(oldMachineSubsidyBill.dealStatus) }}</el-descriptions-item>
      <el-descriptions-item label="失败原因" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ oldMachineSubsidyBill.reason }}</el-descriptions-item>
    </el-descriptions>
    <div style="text-align: center; margin-top: 20px;">
      <el-button @click="$router.back(-1)">返回</el-button>
    </div>
  </div>
</template>
<script>
import { dealStatusMap, orderStateMap, expenseTypeMap, oldMachineCategoryMap, orderStatusMap } from './paymentEnums'
import dayjs from 'dayjs'
export default {
  name: 'oldForNewDetail',
  data() {
    return {
      oldMachineSubsidyBill: {},
      oldMachineSubsidyEntity: {},
      labelStyle: {
        'font-size': '14px',
        'font-weight': '400',
        'text-align': 'left',
        color: '#9d9d9d'
      },
      contentStyle: {
        'font-size': '14px',
        'font-weight': '400',
        'text-align': 'left',
        color: '#333'
      },
      dataVisible:{
        recoveryTel: false,
        receiverAccountNo: false,
        recoveryAddress: false,
      },
      originOldMachineSubsidyBill: {},
      originOldMachineSubsidyEntity: {},
      recoveryTel: '',
      receiverAccountNo: '',
      recoveryAddress:''
    }
  },
  methods: {
    getDetail(billNo) {
      this.HttpService.get(`/autoapp-default-server-recovery/api/oldMachine/subsidyBill/detailByBillNo/${billNo}`).then(res => {
        if (res.statusCode === 200) {
          ;(this.oldMachineSubsidyBill = res.data.oldMachineSubsidyBill), (this.oldMachineSubsidyEntity = res.data.oldMachineSubsidyEntity)
          this.originOldMachineSubsidyBill = res.data.oldMachineSubsidyBill ? {...res.data.oldMachineSubsidyBill}:{}
          this.originOldMachineSubsidyEntity = res.data.oldMachineSubsidyEntity ? {...res.data.oldMachineSubsidyEntity} : {}
        }

            // 根据 sensitizationCode 拆分数据
        if (res.data.desensitizationDtoList && Array.isArray(res.data.desensitizationDtoList)) {
          const phoneMappings = {
            receiverAccountNo_bankCard: 'receiverAccountNo',
            recoveryAddress_address: 'recoveryAddress',
            recoveryTel_phone: 'recoveryTel',
          }

          res.data.desensitizationDtoList.forEach(item => {
            const targetProperty = phoneMappings[item.sensitizationCode]
            if (targetProperty) {
              this[targetProperty] = {
                sensitizationCode: item.sensitizationCode,
                message: item.message
              }
            }
          })
        }
      })
    },
    dealStatusStrFun(type) {
      return dealStatusMap[type] || ''
    },
    oldMachineCategoryStrFun(type) {
      return oldMachineCategoryMap[type] || ''
    },

    orderStatusStrFun(type) {
      return orderStatusMap[type] || ''
    },
    formatDateTime(date) {
      if (!date) {
        return ''
      }
      const parsedDate = dayjs(date)
      return parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD HH:mm:ss') : ''
    },

    getSourceOrigin(data) {
      return this.HttpService.post(`/autoapp-default-server-recovery/api/deSensitization/getSource`, data).then(res => {
        if (res.statusCode === 200) {
          return res.data
        }
      })
    },
    toggleVisibility(dataType) {
      // 切换显示状态
      this.dataVisible[dataType] = !this.dataVisible[dataType]

      // 根据不同类型处理显示逻辑
      switch (dataType) {
        case 'recoveryTel':
          if (this.dataVisible.recoveryTel && this.recoveryTel.message) {
            this.getSourceOrigin(this.recoveryTel).then(res => {
              this.$set(this.oldMachineSubsidyEntity, 'recoveryTel', res)
            })
          } else if (!this.dataVisible.recoveryTel) {
            // 还原为原始脱敏数据
            this.$set(this.oldMachineSubsidyEntity, 'recoveryTel', this.originOldMachineSubsidyEntity.recoveryTel)
          }
          break
        case 'recoveryAddress':
          if (this.dataVisible.recoveryAddress && this.recoveryAddress.message) {
            this.getSourceOrigin(this.recoveryAddress).then(res => {
              this.$set(this.oldMachineSubsidyEntity, 'recoveryAddress', res)
            })
          } else if (!this.dataVisible.recoveryAddress) {
            // 还原为原始脱敏数据
            this.$set(this.oldMachineSubsidyEntity, 'recoveryAddress', this.originOldMachineSubsidyEntity.recoveryAddress)
          }
          break
        case 'receiverAccountNo':
          if(this.dataVisible.receiverAccountNo && this.receiverAccountNo.message){
            this.getSourceOrigin(this.receiverAccountNo).then(res => {
              this.$set(this.oldMachineSubsidyBill, 'receiverAccountNo', res)
            })
          } else if (!this.dataVisible.receiverAccountNo) {
            // 还原为原始脱敏数据
            this.$set(this.oldMachineSubsidyBill, 'receiverAccountNo', this.originOldMachineSubsidyBill.receiverAccountNo)
          }
      }
    }
  },
  mounted() {
    this.getDetail(this.$route.query.billNo)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/paymentManagement/oldForNewDetail.vue